
const DEFAULT_LANGUAGE_ID = 106

export {
  DEFAULT_LANGUAGE_ID
}
